import { takeLatest } from 'redux-saga/effects';
import {
  handleGetAadhaarEsignCredentials,
  handleGetDigioImageVerifyCredentials, handleGetDigioKycCredentials,
  handleSaveUserDeclaration, handleSaveUserSign, handleVerifyAadhaarEsign, handleVerifyDigioImageVerification,
  handleVerifyDigioKyc,
} from './digioFormHandlers';
import {
  getAadhaarEsignCredentials,
  getDigioImageVerifyCredentials, getDigioKycCredentials,
  saveUserDeclaration, saveUserSign, verifyAadhaarEsign, verifyDigioImageVerification, verifyDigioKyc,
} from './digioFormSlice';

export function* getDigioImageVerifyCredentialsSaga() {
  yield takeLatest(getDigioImageVerifyCredentials.type, handleGetDigioImageVerifyCredentials);
}

export function* verifyDigioImageVerificationSaga() {
  yield takeLatest(verifyDigioImageVerification.type, handleVerifyDigioImageVerification);
}

export function* getDigioKycCredentialsSaga() {
  yield takeLatest(getDigioKycCredentials.type, handleGetDigioKycCredentials);
}

export function* verifyDigioKycSaga() {
  yield takeLatest(verifyDigioKyc.type, handleVerifyDigioKyc);
}

export function* getAadhaarEsignCredentialsSaga() {
  yield takeLatest(getAadhaarEsignCredentials.type, handleGetAadhaarEsignCredentials);
}

export function* verifyAadhaarEsignSaga() {
  yield takeLatest(verifyAadhaarEsign.type, handleVerifyAadhaarEsign);
}

export function* saveUserDeclarationSaga() {
  yield takeLatest(saveUserDeclaration.type, handleSaveUserDeclaration);
}

export function* saveUserSignSaga() {
  yield takeLatest(saveUserSign.type, handleSaveUserSign);
}
